import type {FC} from 'react'
import {Box, Label, Text} from '@primer/react'

export type HeaderIssueTypeProps = {
  name: string
}

export function HeaderIssueType({name}: HeaderIssueTypeProps) {
  return (
    <Label
      data-testid="header-issue-type"
      size="large"
      sx={{
        height: '32px',
        px: 'var(--control-small-paddingInline-normal)',
        display: 'flex',
        backgroundColor: 'canvas.inset',
      }}
    >
      <Text sx={{color: 'fg.muted', fontWeight: 600, whiteSpace: 'nowrap', fontSize: 1}}>{name}</Text>
    </Label>
  )
}

export const SmallHeaderIssueType: FC<HeaderIssueTypeProps> = ({name}) => (
  <Box sx={{display: 'flex', flexDirection: 'row'}}>
    <Text sx={{color: 'fg.muted', whiteSpace: 'nowrap'}}>{name}</Text>
  </Box>
)

try{ HeaderIssueType.displayName ||= 'HeaderIssueType' } catch {}
try{ SmallHeaderIssueType.displayName ||= 'SmallHeaderIssueType' } catch {}